import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import router from "./router";
import base from "./router/base";
class App extends React.Component {
  render() {
    return (
      <Router basename="/community-page">
        <Switch>
          {router.map((item) => {
            return (
              <Route
                key={item.name}
                exact
                path={item.route}
                component={item.component}
              ></Route>
            );
          })}
          {base.map((item) => {
            return (
              <Route
                key={item.name}
                path={item.route}
                component={item.component}
              ></Route>
            );
          })}
          {/* <Route path="/" component={() => {
            return <Redirect to="/error" />
          }}></Route> */}
        </Switch>
      </Router>
    );
  }
}

export default App;
